import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/ui-kit";
import { Loader, EmptyState } from "@/components/Loader";
import { Radio, MapPin, Clock, ChevronRight, Inbox, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const fmtTime = (iso) => { try { return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };
const SEV = { Low: "#6b7280", Medium: "#F59E0B", High: "#F97316", Critical: "#DC2626" };

export default function Responder() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  const load = () => api.get("/responder/inbox").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); const iv = setInterval(load, 4000); return () => clearInterval(iv); }, []);

  if (items === null) return <Loader />;

  return (
    <div className="ll-fade-up" data-testid="responder-screen">
      <PageHeader title="Responder inbox" subtitle={`Active emergencies in ${user?.home_community_id ? "your community" : "Govindpur"}`} />
      <div className="px-5">
        <div className="bg-[#111827] text-white rounded-3xl p-4 flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-2xl bg-[#F97316] flex items-center justify-center"><Radio className="w-5 h-5" /></div>
          <div><p className="font-bold">You are visible as a responder</p><p className="text-xs text-white/60">Accepting is live — the resident sees it instantly.</p></div>
        </div>
        {items.length === 0 ? (
          <EmptyState icon={Inbox} title="No active emergencies" subtitle="When a neighbour needs help, it will appear here in real time." />
        ) : (
          <div className="space-y-3">
            {items.map((e) => (
              <button key={e.id} data-testid={`inbox-${e.id}`} onClick={() => navigate(`/emergency/${e.id}`)} className="w-full bg-white rounded-2xl p-4 text-left shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#111827]/5 hover:-translate-y-0.5 transition-transform">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-bold text-white px-2.5 py-0.5 rounded-full" style={{ background: SEV[e.severity] }}>{e.severity}</span>
                  {e.my_status === "accepted" && <span className="text-xs font-bold text-[#16A34A] flex items-center gap-1"><ShieldCheck className="w-3.5 h-3.5" /> Accepted</span>}
                </div>
                <p className="text-lg font-bold">{e.type_label}</p>
                <p className="text-sm text-[#111827]/50 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {e.location_label} · {e.victim_name}</p>
                <div className="flex items-center justify-between mt-2 text-xs text-[#111827]/40 font-semibold">
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {fmtTime(e.started_at)} · {e.distance_km} km</span>
                  <span className="flex items-center gap-1 text-[#F97316]">Open <ChevronRight className="w-3.5 h-3.5" /></span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
